import Api from "../..";
import { FetchLocalizationRequest, FetchLocalizationResponse } from "./types/fetch";

export default class LocalizationApi {
    constructor(protected api: Api) { }

    public async fetch(request: FetchLocalizationRequest) {
        return await this.api.execute(request, FetchLocalizationResponse);
    }
}